export const ROLES = {
  SUPER_ADMIN: "super_admin",
  OWNER: "owner",
  CAMPUS_ADMIN: "campus_admin",
  ADVISOR: "advisor",
  STAFF: "staff",
}

// Emails del equipo de desarrollo con acceso total (credenciales, integraciones, etc).
// Editar esta lista para dar acceso de super admin.
export const SUPER_ADMIN_EMAILS = new Set([
  "yair@tepeyac.mx",
  "yairhdz24@gmail.com",
  "admin@tepeyac.mx",
  "ramon@tepeyac.mx",
])

/**
 * Super admin = developer. Ve TODO, puede editar cualquier cosa,
 * tiene acceso al panel de WhatsApp/Evolution y credenciales.
 * Es un rol por encima de "owner" / "admin".
 */
export function isSuperAdmin(user) {
  if (!user) return false
  const email = String(user?.email || "").toLowerCase().trim()
  if (email && SUPER_ADMIN_EMAILS.has(email)) return true
  return (
    user?.role === ROLES.SUPER_ADMIN ||
    user?.rol === "super_admin" ||
    user?.isSuperAdmin === true
  )
}

export function isOwner(user) {
  if (!user) return false
  if (isSuperAdmin(user)) return true
  return user?.role === ROLES.OWNER || user?.rol === "owner" || user?.isOwner || user?.isAdmin === "owner"
}

export function isCampusAdmin(user) {
  if (!user) return false
  return user?.role === ROLES.CAMPUS_ADMIN || user?.rol === "campus_admin" || user?.isCampusAdmin || user?.isAdmin === true || user?.rol === "admin"
}

export function isAdvisor(user) {
  if (!user) return false
  return user?.role === ROLES.ADVISOR || user?.rol === "advisor" || !!user?.isAdvisor
}

/**
 * Devuelve lista de campus accesibles para el usuario.
 * - owner: todos (se representará con "Todos" en UI cuando proceda)
 * - campus admin / advisor: su campus (extrae user.campus o por email en asesores)
 */
export function getAccessibleCampuses(user, allCampuses = [], asesores = []) {
  if (!user) return []

  if (isOwner(user)) return Array.isArray(allCampuses) && allCampuses.length > 0 ? allCampuses : ["Todos"]

  const maybeCampus = user?.campus || user?.campus_id || user?.campusName
  if (maybeCampus) return [String(maybeCampus)]

  const email = String((user?.email || "").toLowerCase())
  if (email) {
    const found = (asesores || []).find(a => String(a.email || "").toLowerCase() === email)
    if (found && found.campus) return [found.campus]
  }

  return []
}

export function filterAdvisorsForUser(advisors = [], user, allCampuses = []) {
  if (!user) return []
  if (isOwner(user)) return advisors
  const allowed = getAccessibleCampuses(user, allCampuses, advisors)
  if (!allowed || allowed.length === 0) return []
  return advisors.filter(a => allowed.includes(a.campus) || allowed.includes("Todos"))
}
